import { useEffect } from "react";
import { useParams } from "react-router-dom";

import Loader from "components/Loader";
import PageNotFound from "pages/404";

import { useGetEmployeeAccess } from "./useGetEmployeeAccess";
import { useGetUserAssociatedCorpList } from "./useGetUserAssociatedCorpList";
import { querygetCorporationProfileInfo } from "@type/api/corporation/getCorpProfileInfo";
import { useAuthStore, useCorporationStore, useLayoutStore } from "@type/store";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface CorporationDataWrapperProps {
  children: React.ReactNode;
}

const CorporationDataWrapper = ({ children }: CorporationDataWrapperProps) => {
  const { loading, mapCorpList } = useGetUserAssociatedCorpList({
    page: 1,
    perPage: 6,
  });

  const onSetSelectedCorp = useCorporationStore(
    (state) => state.onSetSelectedCorp
  );
  const onSetMapCorpList = useCorporationStore(
    (state) => state.onSetMapCorpList
  );
  const onSetLoading = useCorporationStore((state) => state.onSetLoading);

  const { corporationSlug } = useParams();
  const isDataNotFound = useLayoutStore((state) => state.isDataNotFound);
  const selectedCorp = useCorporationStore((state) => state.selectedCorp);
  const user = useAuthStore((state) => state.user);
  const onSetIsDataNotFound = useLayoutStore(
    (state) => state.onSetIsDataNotFound
  );

  const { isLoading } = useQueryWithCallbacks({
    queryKey: querygetCorporationProfileInfo._key(corporationSlug || ""),
    enabled: !!corporationSlug,
    queryFn: () => querygetCorporationProfileInfo(corporationSlug || ""),
    onSuccess: (res) => {
      onSetSelectedCorp({
        ...res,
        slug: res.idUnique,
      });
      onSetIsDataNotFound(false);
      onSetLoading(false);
    },
    onError: () => {
      onSetIsDataNotFound(true);
      onSetLoading(false);
    },
  });

  useGetEmployeeAccess({
    params: {
      corpId: selectedCorp?.idUnique || "",
      userId: user.idUnique,
    },
  });

  useEffect(() => {
    if (!loading && mapCorpList !== undefined) {
      onSetMapCorpList(mapCorpList);
    }
  }, [loading, mapCorpList, onSetMapCorpList]);

  if (isLoading) {
    return <Loader />;
  }

  if (isDataNotFound) {
    return <PageNotFound />;
  }

  return <>{children}</>;
};

export default CorporationDataWrapper;
